<template>
  <div class="highlights-default-model-container px-2">
    <div class="app-section first"></div>
    <div class="products-section">
      <div class="products-section-header d-flex flex-row align-center mb-2">
        <div class="icon-image">
          <img v-if="hasIconImage" :src="imagePath" alt="Icon do destaque padrão" />
        </div>
        <h1 class="display-title">{{ displayTitle }}</h1>
      </div>
      <div class="products-section-cards d-flex flex-row justify-space-between">
        <product-card
          v-for="image in productsImages"
          :key="`product-${image}`"
          variant="basic"
          :product-image-src="`highlight-products-images/product-${image}.png`"
        />
      </div>
    </div>
    <div class="d-flex flex-row justify-space-between second">
      <div class="app-section"></div>
      <div class="app-section"></div>
    </div>
  </div>
</template>
<script>
import { highlightOffer } from '../../../mixins/highlight-offer'
export default {
  name: 'DefaultModel',
  components: {
    ProductCard: () => import('./ProductCard.vue'),
  },
  mixins: [highlightOffer],
  data: () => ({
    productsImages: ['cheetos', 'coca', 'beats-2', 'meat'],
  }),
  computed: {
    displayTitle() {
      return (this.isDefaultModel && this.highlightDisplayTitle) || 'Título de exibição'
    },
    imagePath() {
      return this.highlightIconImage
    },
    hasIconImage() {
      return this.imagePath.length > 0 && this.isDefaultModel
    },
  },
  methods: {},
}
</script>
<style lang="scss" scoped>
.highlights-default-model-container {
  display: flex;
  flex-direction: column;
  gap: 16px;
  .app-section {
    border-radius: 25px;
    background: $cinza-l90;
    width: 100%;
    height: 170px;
  }
  .first {
    border-radius: 0 0 25px 25px !important;
    height: 130px !important;
  }
  .second {
    border-radius: 0 0 25px 25px !important;
    gap: 12px;
  }
  .products-section {
    height: auto;
    padding: 8px;
    border-radius: 8px;
    background-color: #f1f0ee;
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.16);
    .products-section-header {
      gap: 8px;
      .display-title {
        color: #565656;
        font-family: Poppins;
        font-size: 12px;
        font-style: normal;
        font-weight: 600;
        line-height: 150%;
      }
      .icon-image {
        height: 28px;
        width: 28px;
        border-radius: 50%;
        background: linear-gradient(124deg, #ccd3d9 11.62%, #e6e8ea 51.08%, #ccd3d9 84.7%);
        img {
          width: 100%;
          height: 100%;
          border-radius: 50%;
        }
      }
    }
  }
}
</style>
